// tslint:disable
import { Injectable } from '@angular/core';

import { DwItem, DwItemDetail, DwQuery, DwOrmData } from '@devwareapps/devware-cap';
import * as EnterpriseMetaData from '@devwareapps/devware-cap';

/************************************************
   Generated with the Devware CAP CLI 4.4.18
   Code Gen Name   ProofOfInsurance
   API Url         https://wappsdev.wachter.com/DevwareCapApi/

   Generated By    WACHTER/christopher.hinkle
   Generate On     10/24/2022 11:30:53 AM
************************************************/

export enum ProofOfInsuranceMetaDataItemNames {
    EthosUser = 'Ethos_User',
    EthosUserDiff = 'Ethos_UserDiff',
    EthosUserSkill = 'Ethos_UserSkill',
    PolicyType = 'PolicyType',
    ProofOfInsurance = 'ProofOfInsurance',
    ProofOfInsuranceJobTitles = 'ProofOfInsuranceJobTitles',
    ProofOfInsuranceStatus = 'ProofOfInsuranceStatus',
    ProofOfInsuranceSummary = 'ProofOfInsuranceSummary',
    ProofOfInsuranceSummaryStatus = 'ProofOfInsuranceSummaryStatus',
    RoEthosUser = 'roEthos_User',
    RoEthosUserOriginal = 'roEthos_UserOriginal',
    RoVehicleAccidents = 'roVehicleAccidents',
    VehicleType = 'VehicleType',
}

export enum ProofOfInsuranceMetaDataLookups {
    EthosUserBySupervisor = 1758,
    EthosUserBySupervisorPlusIndirect = 1773,
    EthosUserByUsersDepartment = 1582,
    ETHOSUSERNSPLBUOfficeActiveEmployees = 1696,
    ETHOSUSERWachterEmployeesActiveEmployees = 1464,
    EthosUserAllItems = 1416,
    EthosUserDiffAllItems = 1623,
    EthosUserSkillAllItems = 1413,
    PolicyTypeAllItems = 1756,
    ProofOfInsuranceAllItems = 1755,
    ProofOfInsuranceJobTitlesAllItems = 1800,
    ProofOfInsuranceStatusDeletedRemoved = 1759,
    ProofOfInsuranceStatusAllItems = 1757,
    ProofOfInsuranceSummaryAllItems = 1775,
    ProofOfInsuranceSummaryStatusAllItems = 1790,
    RoEthosUserAllItems = 1422,
    RoEthosUserOriginalAllItems = 1753,
    RoVehicleAccidentsAllItems = 1552,
    VehicleTypeAllItems = 1772,
}

@Injectable({
    providedIn: 'root'
})
export class ProofOfInsuranceMetaDataService {

    EthosUser : EthosUser = new EthosUser();
    EthosUserDiff : EthosUserDiff = new EthosUserDiff();
    EthosUserSkill : EthosUserSkill = new EthosUserSkill();
    PolicyType : PolicyType = new PolicyType();
    ProofOfInsurance : ProofOfInsurance = new ProofOfInsurance();
    ProofOfInsuranceJobTitles : ProofOfInsuranceJobTitles = new ProofOfInsuranceJobTitles();
    ProofOfInsuranceStatus : ProofOfInsuranceStatus = new ProofOfInsuranceStatus();
    ProofOfInsuranceSummary : ProofOfInsuranceSummary = new ProofOfInsuranceSummary();
    ProofOfInsuranceSummaryStatus : ProofOfInsuranceSummaryStatus = new ProofOfInsuranceSummaryStatus();
    RoEthosUser : RoEthosUser = new RoEthosUser();
    RoEthosUserOriginal : RoEthosUserOriginal = new RoEthosUserOriginal();
    RoVehicleAccidents : RoVehicleAccidents = new RoVehicleAccidents();
    VehicleType : VehicleType = new VehicleType();
}

// Generated Classes for MetaData service
class EthosUser implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_User.';

    constructor() {
        this.ItemDetail.ItemId=2413;
        this.ItemDetail.ItemName='Ethos_User';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    UserName : string = this.i + 'UserName';
    FirstName : string = this.i + 'FirstName';
    LastName : string = this.i + 'LastName';
    MiddleName : string = this.i + 'MiddleName';
    PreferredName : string = this.i + 'PreferredName';
    Suffix : string = this.i + 'Suffix';
    OfficePhone : string = this.i + 'OfficePhone';
    MobilePhone : string = this.i + 'MobilePhone';
    WachterJobTitleId : string = this.i + 'WachterJobTitleId';
    WachterJobTitle : string = this.i + 'WachterJobTitle';
    UserTypeCv : string = this.i + 'UserTypeCv';
    UserTypeDisplay : string = this.i + 'UserTypeDisplay';
    StaffingAgencyId : string = this.i + 'StaffingAgencyId';
    ResourceGroupCv : string = this.i + 'ResourceGroupCv';
    ResourceGroup : string = this.i + 'ResourceGroup';
    EmployeeGroupId : string = this.i + 'EmployeeGroupId';
    EmployeeGroupCode : string = this.i + 'EmployeeGroupCode';
    EmployeeGroupDescription : string = this.i + 'EmployeeGroupDescription';
    EmpHireDate : string = this.i + 'empHireDate';
    AddressLongitude : string = this.i + 'AddressLongitude';
    AddressLatitude : string = this.i + 'AddressLatitude';
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    BirthMonth : string = this.i + 'BirthMonth';
    BirthDate : string = this.i + 'BirthDate';
    Email : string = this.i + 'Email';
    SupervisorUserId : string = this.i + 'SupervisorUserId';
    UserStatusWs : string = this.i + 'UserStatusWs';
    UserStatusMeaning : string = this.i + 'UserStatusMeaning';
    IsTerminated : string = this.i + 'IsTerminated';
    PictureAttachmentFileExtension : string = this.i + 'PictureAttachmentFileExtension';
    PictureAttachmentDisplay : string = this.i + 'PictureAttachmentDisplay';
    PictureAttachmentField : string = this.i + 'PictureAttachmentField';
    AdjustedStartDate : string = this.i + 'AdjustedStartDate';
    OfficeId : string = this.i + 'OfficeId';
    OfficeName : string = this.i + 'OfficeName';
    StreetAddress1 : string = this.i + 'StreetAddress1';
    StreetAddress2 : string = this.i + 'StreetAddress2';
    City : string = this.i + 'City';
    StateProvinceShortName : string = this.i + 'StateProvinceShortName';
    PostalCode : string = this.i + 'PostalCode';
    HasVehicle : string = this.i + 'HasVehicle';
    ShowUserOnMap : string = this.i + 'ShowUserOnMap';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';
    EmployeeType : string = this.i + 'EmployeeType';
    StateProvinceId : string = this.i + 'StateProvinceId';
    PictureAttachmentFileKey : string = this.i + 'PictureAttachmentFileKey';
    CustomerId : string = this.i + 'CustomerId';
    SubcontractorId : string = this.i + 'SubcontractorId';
    SpecialInstructions : string = this.i + 'SpecialInstructions';
    IsVaxxed : string = this.i + 'isVaxxed';

    Relations = {
            /** Relation: Ethos User - Supervisor User - Many */
            EthosUserBySupervisorUserId : {
                RelationName: 'Supervisor_User2',
                FieldPrefix: 'SupervisorEthosUser',
                PropertyName: 'SupervisorEthosUser'
            },
            /** Relation: Proof Of Insurance Job Titles */
            ProofOfInsuranceJobTitlesByWachterJobTitleId : {
                RelationName: 'Ethos_User|ProofOfInsuranceJobTitles|WachterJobTitleId',
                FieldPrefix: 'ProofOfInsuranceJobTitlesWachterJobTitleId',
                PropertyName: 'ProofOfInsuranceJobTitlesWachterJobTitleId'
            },
            /** Relation: Proof Of Insurance Summary - Employee - Many */
            ProofOfInsuranceSummaryByEmployeeEthosUserId : {
                RelationName: 'ProofOfInsuranceSummary|EthosUser|EmployeeEthos_UserId',
                FieldPrefix: 'EmployeeEthosProofOfInsuranceSummary',
                PropertyName: 'EmployeeEthosProofOfInsuranceSummary'
            },
            /** Relation: Ro Ethos User */
            RoEthosUser : {
                RelationName: 'Ethos_User|roEthos_User|UserId',
                FieldPrefix: 'RoEthosUser',
                PropertyName: 'RoEthosUser'
            },
    };
}

class EthosUserDiff implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_UserDiff.';

    constructor() {
        this.ItemDetail.ItemId=2572;
        this.ItemDetail.ItemName='Ethos_UserDiff';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EthosUserDiffId : string = this.i + 'Ethos_UserDiffId';
    EthosUserId : string = this.i + 'Ethos_UserId';
    FieldName : string = this.i + 'FieldName';
    OldValue : string = this.i + 'OldValue';
    NewValue : string = this.i + 'NewValue';
    ChangedDateTime : string = this.i + 'ChangedDateTime';

    Relations = {
    };
}

class EthosUserSkill implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_UserSkill.';

    constructor() {
        this.ItemDetail.ItemId=2410;
        this.ItemDetail.ItemName='Ethos_UserSkill';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserSkillId : string = this.i + 'UserSkillId';
    UserId : string = this.i + 'UserId';
    SkillCv : string = this.i + 'SkillCv';
    Dislay : string = this.i + 'Dislay';
    Meaning : string = this.i + 'Meaning';

    Relations = {
    };
}

class PolicyType implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'PolicyType.';

    constructor() {
        this.ItemDetail.ItemId=2664;
        this.ItemDetail.ItemName='PolicyType';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PolicyTypeId : string = this.i + 'PolicyTypeId';
    PolicyType : string = this.i + 'PolicyType';

    Relations = {
            /** Relation: Proof Of Insurance */
            ProofOfInsurance : {
                RelationName: 'PolicyType|ProofOfInsurance|PolicyTypeId',
                FieldPrefix: 'ProofOfInsurance',
                PropertyName: 'ProofOfInsurance'
            },
    };
}

class ProofOfInsurance implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'ProofOfInsurance.';

    constructor() {
        this.ItemDetail.ItemId=2663;
        this.ItemDetail.ItemName='ProofOfInsurance';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    ProofOfInsuranceId : string = this.i + 'ProofOfInsuranceId';
    PolicyNumber : string = this.i + 'PolicyNumber';
    PolicyTypeId : string = this.i + 'PolicyTypeId';
    IssuedTo : string = this.i + 'IssuedTo';
    InsuranceCompany : string = this.i + 'InsuranceCompany';
    IssueDate : string = this.i + 'IssueDate';
    ExpirationDate : string = this.i + 'ExpirationDate';
    LicenseVerified : string = this.i + 'LicenseVerified';
    POIStatusId : string = this.i + 'POIStatusId';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    AttachmentFileId : string = this.i + 'AttachmentFileId';
    Notes : string = this.i + 'Notes';
    CountryId : string = this.i + 'CountryId';
    StateProvinceId : string = this.i + 'StateProvinceId';
    VehicleTypeId : string = this.i + 'VehicleTypeId';
    ProofOfInsuranceSummaryId : string = this.i + 'ProofOfInsuranceSummaryId';
    SignedCorpFleetPolicy : string = this.i + 'SignedCorpFleetPolicy';
    IsCurrent : string = this.i + 'IsCurrent';

    Relations = {
            /** Relation: Proof Of Insurance Summary */
            ProofOfInsuranceSummary : {
                RelationName: 'ProofOfInsuranceSummary|ProofOfInsurance|ProofOfInsuranceSummaryId',
                FieldPrefix: 'ProofOfInsuranceSummary',
                PropertyName: 'ProofOfInsuranceSummary'
            },
            /** Relation: Proof Of Insurance Status */
            ProofOfInsuranceStatus : {
                RelationName: 'ProofOfInsuranceStatus|ProofOfInsurance|POIStatusId',
                FieldPrefix: 'ProofOfInsuranceStatus',
                PropertyName: 'ProofOfInsuranceStatus'
            },
            /** Relation: Vehicle Type */
            VehicleType : {
                RelationName: 'VehicleType|ProofOfInsurance|VehicleTypeId',
                FieldPrefix: 'VehicleType',
                PropertyName: 'VehicleType'
            },
            /** Relation: Policy Type */
            PolicyType : {
                RelationName: 'PolicyType|ProofOfInsurance|PolicyTypeId',
                FieldPrefix: 'PolicyType',
                PropertyName: 'PolicyType'
            },
    };
}

class ProofOfInsuranceJobTitles implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'ProofOfInsuranceJobTitles.';

    constructor() {
        this.ItemDetail.ItemId=2696;
        this.ItemDetail.ItemName='ProofOfInsuranceJobTitles';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    ProofOfInsuranceJobTitlesId : string = this.i + 'ProofOfInsuranceJobTitlesId';
    WachterJobTitleId : string = this.i + 'WachterJobTitleId';

    Relations = {
            /** Relation: Ethos User */
            EthosUserByWachterJobTitleId : {
                RelationName: 'Ethos_User|ProofOfInsuranceJobTitles|WachterJobTitleId',
                FieldPrefix: 'EthosUserWachterJobTitleId',
                PropertyName: 'EthosUserWachterJobTitleId'
            },
    };
}

class ProofOfInsuranceStatus implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'ProofOfInsuranceStatus.';

    constructor() {
        this.ItemDetail.ItemId=2665;
        this.ItemDetail.ItemName='ProofOfInsuranceStatus';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    POIStatusId : string = this.i + 'POIStatusId';
    POIStatus : string = this.i + 'POIStatus';
    ButtonClasses : string = this.i + 'ButtonClasses';
    ValidationRequired : string = this.i + 'ValidationRequired';
    StatusActionText : string = this.i + 'StatusActionText';

    Relations = {
            /** Relation: Proof Of Insurance */
            ProofOfInsurance : {
                RelationName: 'ProofOfInsuranceStatus|ProofOfInsurance|POIStatusId',
                FieldPrefix: 'ProofOfInsurance',
                PropertyName: 'ProofOfInsurance'
            },
    };
}

class ProofOfInsuranceSummary implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'ProofOfInsuranceSummary.';

    constructor() {
        this.ItemDetail.ItemId=2677;
        this.ItemDetail.ItemName='ProofOfInsuranceSummary';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    ProofOfInsuranceSummaryId : string = this.i + 'ProofOfInsuranceSummaryId';
    IsApprovedDriver : string = this.i + 'IsApprovedDriver';
    CanUsePersonalVehicle : string = this.i + 'CanUsePersonalVehicle';
    HasPoiOnPersonalVehicle : string = this.i + 'HasPoiOnPersonalVehicle';
    NeedsTrustUpdate : string = this.i + 'NeedsTrustUpdate';
    EmployeeEthosUserId : string = this.i + 'EmployeeEthos_UserId';
    ProofOfInsuranceSummaryStatusId : string = this.i + 'ProofOfInsuranceSummaryStatusId';

    Relations = {
            /** Relation: Proof Of Insurance Summary Status */
            ProofOfInsuranceSummaryStatus : {
                RelationName: 'ProofOfInsuranceSummaryStatus|ProofOfInsuranceSummary|ProofOfInsuranceSummaryStatusId',
                FieldPrefix: 'ProofOfInsuranceSummaryStatus',
                PropertyName: 'ProofOfInsuranceSummaryStatus'
            },
            /** Relation: Proof Of Insurance */
            ProofOfInsurance : {
                RelationName: 'ProofOfInsuranceSummary|ProofOfInsurance|SummaryId',
                FieldPrefix: 'ProofOfInsurance',
                PropertyName: 'ProofOfInsurance'
            },
            /** Relation: Ethos User - Employee */
            EthosUserByEmployeeEthosUserId : {
                RelationName: 'ProofOfInsuranceSummary|EthosUser|EmployeeEthos_UserId',
                FieldPrefix: 'EmployeeEthosEthosUser',
                PropertyName: 'EmployeeEthosEthosUser'
            },
    };
}

class ProofOfInsuranceSummaryStatus implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'ProofOfInsuranceSummaryStatus.';

    constructor() {
        this.ItemDetail.ItemId=2691;
        this.ItemDetail.ItemName='ProofOfInsuranceSummaryStatus';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    ProofOfInsuranceSummaryStatusId : string = this.i + 'ProofOfInsuranceSummaryStatusId';
    ProofOfInsuranceSummaryStatusDisplay : string = this.i + 'ProofOfInsuranceSummaryStatusDisplay';

    Relations = {
            /** Relation: Proof Of Insurance Summary */
            ProofOfInsuranceSummary : {
                RelationName: 'ProofOfInsuranceSummaryStatus|ProofOfInsuranceSummary|ProofOfInsuranceSummaryStatusId',
                FieldPrefix: 'ProofOfInsuranceSummary',
                PropertyName: 'ProofOfInsuranceSummary'
            },
    };
}

class RoEthosUser implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roEthos_User.';

    constructor() {
        this.ItemDetail.ItemId=2419;
        this.ItemDetail.ItemName='roEthos_User';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    UserName : string = this.i + 'UserName';
    FirstName : string = this.i + 'FirstName';
    LastName : string = this.i + 'LastName';
    MiddleName : string = this.i + 'MiddleName';
    PreferredName : string = this.i + 'PreferredName';
    Suffix : string = this.i + 'Suffix';
    OfficePhone : string = this.i + 'OfficePhone';
    MobilePhone : string = this.i + 'MobilePhone';
    WachterJobTitleId : string = this.i + 'WachterJobTitleId';
    WachterJobTitle : string = this.i + 'WachterJobTitle';
    UserTypeCv : string = this.i + 'UserTypeCv';
    UserTypeDisplay : string = this.i + 'UserTypeDisplay';
    StaffingAgencyId : string = this.i + 'StaffingAgencyId';
    ResourceGroupCv : string = this.i + 'ResourceGroupCv';
    ResourceGroup : string = this.i + 'ResourceGroup';
    EmployeeGroupId : string = this.i + 'EmployeeGroupId';
    EmployeeGroupCode : string = this.i + 'EmployeeGroupCode';
    EmployeeGroupDescription : string = this.i + 'EmployeeGroupDescription';
    EmpHireDate : string = this.i + 'empHireDate';
    AddressLongitude : string = this.i + 'AddressLongitude';
    AddressLatitude : string = this.i + 'AddressLatitude';
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    BirthMonth : string = this.i + 'BirthMonth';
    BirthDate : string = this.i + 'BirthDate';
    Email : string = this.i + 'Email';
    SupervisorUserId : string = this.i + 'SupervisorUserId';
    UserStatusWs : string = this.i + 'UserStatusWs';
    UserStatusMeaning : string = this.i + 'UserStatusMeaning';
    IsTerminated : string = this.i + 'IsTerminated';
    PictureAttachmentFileExtension : string = this.i + 'PictureAttachmentFileExtension';
    PictureAttachmentDisplay : string = this.i + 'PictureAttachmentDisplay';
    PictureAttachmentField : string = this.i + 'PictureAttachmentField';
    AdjustedStartDate : string = this.i + 'AdjustedStartDate';
    OfficeId : string = this.i + 'OfficeId';
    OfficeName : string = this.i + 'OfficeName';
    StreetAddress1 : string = this.i + 'StreetAddress1';
    StreetAddress2 : string = this.i + 'StreetAddress2';
    City : string = this.i + 'City';
    StateProvinceShortName : string = this.i + 'StateProvinceShortName';
    PostalCode : string = this.i + 'PostalCode';
    HasVehicle : string = this.i + 'HasVehicle';
    ShowUserOnMap : string = this.i + 'ShowUserOnMap';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';
    TeamName : string = this.i + 'TeamName';
    TeamShortName : string = this.i + 'TeamShortName';
    TeamNickName : string = this.i + 'TeamNickName';
    DepartmentName : string = this.i + 'DepartmentName';
    DepartmentShortName : string = this.i + 'DepartmentShortName';
    WachterDivisionId : string = this.i + 'WachterDivisionId';
    DivisionName : string = this.i + 'DivisionName';
    DivisionShortName : string = this.i + 'DivisionShortName';
    NameLastFirst : string = this.i + 'NameLastFirst';
    NameLastPrefered : string = this.i + 'NameLastPrefered';
    NameLastFirstPrefered : string = this.i + 'NameLastFirstPrefered';
    NameFirstLast : string = this.i + 'NameFirstLast';
    NamePreferedLast : string = this.i + 'NamePreferedLast';
    NameFirstPreferedLast : string = this.i + 'NameFirstPreferedLast';
    NameFirstMiddleLast : string = this.i + 'NameFirstMiddleLast';
    NamePreferedMidInitialLast : string = this.i + 'NamePreferedMidInitialLast';
    NameLastFirstPreferedStatus : string = this.i + 'NameLastFirstPreferedStatus';
    EmployeeType : string = this.i + 'EmployeeType';
    StateProvinceId : string = this.i + 'StateProvinceId';
    PictureAttachmentFileKey : string = this.i + 'PictureAttachmentFileKey';
    NameLastFirstPreferedType : string = this.i + 'NameLastFirstPreferedType';
    IsActive : string = this.i + 'IsActive';
    SpecialInstructions : string = this.i + 'SpecialInstructions';
    BirthMonthDate : string = this.i + 'BirthMonthDate';
    TerritoryId : string = this.i + 'TerritoryId';
    TerritoryName : string = this.i + 'TerritoryName';
    Company : string = this.i + 'Company';
    LicenseCount : string = this.i + 'LicenseCount';
    AXId : string = this.i + 'AXId';

    Relations = {
            /** Relation: Ethos User */
            EthosUser : {
                RelationName: 'Ethos_User|roEthos_User|UserId',
                FieldPrefix: 'EthosUser',
                PropertyName: 'EthosUser'
            },
            /** Relation: Ro Ethos User - Supervisor User - One */
            RoEthosUserBySupervisorUserId : {
                RelationName: 'roEthos_User|roEthos_User|SupervisorId',
                FieldPrefix: 'SupervisorRoEthosUser',
                PropertyName: 'SupervisorRoEthosUser'
            },
    };
}

class RoEthosUserOriginal implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roEthos_UserOriginal.';

    constructor() {
        this.ItemDetail.ItemId=2661;
        this.ItemDetail.ItemName='roEthos_UserOriginal';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    AXId : string = this.i + 'AXId';
    UserName : string = this.i + 'UserName';
    FirstName : string = this.i + 'FirstName';
    LastName : string = this.i + 'LastName';
    MiddleName : string = this.i + 'MiddleName';
    PreferredName : string = this.i + 'PreferredName';
    Suffix : string = this.i + 'Suffix';
    OfficePhone : string = this.i + 'OfficePhone';
    MobilePhone : string = this.i + 'MobilePhone';
    WachterJobTitleId : string = this.i + 'WachterJobTitleId';
    WachterJobTitle : string = this.i + 'WachterJobTitle';
    UserTypeCv : string = this.i + 'UserTypeCv';
    UserTypeDisplay : string = this.i + 'UserTypeDisplay';
    EmployeeType : string = this.i + 'EmployeeType';
    StaffingAgencyId : string = this.i + 'StaffingAgencyId';
    ResourceGroupCv : string = this.i + 'ResourceGroupCv';
    ResourceGroup : string = this.i + 'ResourceGroup';
    EmployeeGroupId : string = this.i + 'EmployeeGroupId';
    EmployeeGroupCode : string = this.i + 'EmployeeGroupCode';
    EmployeeGroupDescription : string = this.i + 'EmployeeGroupDescription';
    EmpHireDate : string = this.i + 'empHireDate';
    AddressLongitude : string = this.i + 'AddressLongitude';
    AddressLatitude : string = this.i + 'AddressLatitude';
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    BirthMonth : string = this.i + 'BirthMonth';
    BirthDate : string = this.i + 'BirthDate';
    BirthMonthDate : string = this.i + 'BirthMonthDate';
    Email : string = this.i + 'Email';
    SupervisorUserId : string = this.i + 'SupervisorUserId';
    UserStatusWs : string = this.i + 'UserStatusWs';
    UserStatusMeaning : string = this.i + 'UserStatusMeaning';
    IsActive : string = this.i + 'IsActive';
    IsTerminated : string = this.i + 'IsTerminated';
    PictureAttachmentFileExtension : string = this.i + 'PictureAttachmentFileExtension';
    PictureAttachmentDisplay : string = this.i + 'PictureAttachmentDisplay';
    PictureAttachmentFileKey : string = this.i + 'PictureAttachmentFileKey';
    PictureAttachmentField : string = this.i + 'PictureAttachmentField';
    AdjustedStartDate : string = this.i + 'AdjustedStartDate';
    OfficeId : string = this.i + 'OfficeId';
    OfficeName : string = this.i + 'OfficeName';
    StreetAddress1 : string = this.i + 'StreetAddress1';
    StreetAddress2 : string = this.i + 'StreetAddress2';
    City : string = this.i + 'City';
    StateProvinceId : string = this.i + 'StateProvinceId';
    StateProvinceShortName : string = this.i + 'StateProvinceShortName';
    TerritoryId : string = this.i + 'TerritoryId';
    TerritoryName : string = this.i + 'TerritoryName';
    PostalCode : string = this.i + 'PostalCode';
    HasVehicle : string = this.i + 'HasVehicle';
    ShowUserOnMap : string = this.i + 'ShowUserOnMap';
    SpecialInstructions : string = this.i + 'SpecialInstructions';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';
    TeamName : string = this.i + 'TeamName';
    TeamShortName : string = this.i + 'TeamShortName';
    TeamNickName : string = this.i + 'TeamNickName';
    DepartmentName : string = this.i + 'DepartmentName';
    DepartmentShortName : string = this.i + 'DepartmentShortName';
    WachterDivisionId : string = this.i + 'WachterDivisionId';
    DivisionName : string = this.i + 'DivisionName';
    DivisionShortName : string = this.i + 'DivisionShortName';
    Company : string = this.i + 'Company';
    LicenseCount : string = this.i + 'LicenseCount';
    NameLastFirst : string = this.i + 'NameLastFirst';
    NameLastPrefered : string = this.i + 'NameLastPrefered';
    NameLastFirstPrefered : string = this.i + 'NameLastFirstPrefered';
    NameFirstLast : string = this.i + 'NameFirstLast';
    NamePreferedLast : string = this.i + 'NamePreferedLast';
    NameFirstPreferedLast : string = this.i + 'NameFirstPreferedLast';
    NameFirstMiddleLast : string = this.i + 'NameFirstMiddleLast';
    NamePreferedMidInitialLast : string = this.i + 'NamePreferedMidInitialLast';
    NameLastFirstPreferedStatus : string = this.i + 'NameLastFirstPreferedStatus';
    NameLastFirstPreferedType : string = this.i + 'NameLastFirstPreferedType';

    Relations = {
    };
}

class RoVehicleAccidents implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roVehicleAccidents.';

    constructor() {
        this.ItemDetail.ItemId=2519;
        this.ItemDetail.ItemName='roVehicleAccidents';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    VehicleAccidentId : string = this.i + 'VehicleAccidentId';
    EmployeeId : string = this.i + 'EmployeeId';
    PhoneNumber : string = this.i + 'PhoneNumber';
    WJID : string = this.i + 'WJID';
    AccidentDateTime : string = this.i + 'AccidentDateTime';
    AuthorityContacted : string = this.i + 'AuthorityContacted';
    ReportNumber : string = this.i + 'ReportNumber';
    DriverStreetAddress : string = this.i + 'DriverStreetAddress';
    DriverCity : string = this.i + 'DriverCity';
    DriverState : string = this.i + 'DriverState';
    DriverZip : string = this.i + 'DriverZip';
    AccidentAddress : string = this.i + 'AccidentAddress';
    AccidentCity : string = this.i + 'AccidentCity';
    AccidentState : string = this.i + 'AccidentState';
    AccidentZip : string = this.i + 'AccidentZip';
    AccidentTypeCv : string = this.i + 'AccidentTypeCv';
    AccidentAtFaultCv : string = this.i + 'AccidentAtFaultCv';
    VehicleRepairedCv : string = this.i + 'VehicleRepairedCv';
    Injuries : string = this.i + 'Injuries';
    OOPClaimExpense : string = this.i + 'OOPClaimExpense';
    InsurancePaidPDLTInsuredVehicle : string = this.i + 'InsurancePaidPDLTInsuredVehicle';
    InsurancePaidPDLTClaimantVehicle : string = this.i + 'InsurancePaidPDLTClaimantVehicle';
    OtherVehiclesInvolved : string = this.i + 'OtherVehiclesInvolved';
    IsDot : string = this.i + 'IsDot';
    AccidentDescription : string = this.i + 'AccidentDescription';
    AttachmentId : string = this.i + 'AttachmentId';
    ClaimNumber : string = this.i + 'ClaimNumber';
    ClaimStatusCv : string = this.i + 'ClaimStatusCv';
    ClaimInsuranceCompanyCv : string = this.i + 'ClaimInsuranceCompanyCv';
    ClaimInsuranceCompanyText : string = this.i + 'ClaimInsuranceCompanyText';
    AdvisorName : string = this.i + 'AdvisorName';
    AdvisorPhone : string = this.i + 'AdvisorPhone';
    ClaimFiledDate : string = this.i + 'ClaimFiledDate';
    ClaimComments : string = this.i + 'ClaimComments';
    CreatedbyEthosUserId : string = this.i + 'CreatedbyEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    SharepointMigrationId : string = this.i + 'SharepointMigrationId';
    AccidentDateMonth : string = this.i + 'AccidentDateMonth';
    StateDisplay : string = this.i + 'StateDisplay';
    IsPoliceReportObtained : string = this.i + 'IsPoliceReportObtained';

    Relations = {
    };
}

class VehicleType implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'VehicleType.';

    constructor() {
        this.ItemDetail.ItemId=2675;
        this.ItemDetail.ItemName='VehicleType';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    VehicleTypeId : string = this.i + 'VehicleTypeId';
    VehicleTypeDisplay : string = this.i + 'VehicleTypeDisplay';

    Relations = {
            /** Relation: Proof Of Insurance */
            ProofOfInsurance : {
                RelationName: 'VehicleType|ProofOfInsurance|VehicleTypeId',
                FieldPrefix: 'ProofOfInsurance',
                PropertyName: 'ProofOfInsurance'
            },
    };
}


// Generated Entity Interfaces
export interface EthosUserEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    UserName?: string;
    FirstName?: string;
    LastName?: string;
    MiddleName?: string;
    PreferredName?: string;
    Suffix?: string;
    OfficePhone?: string;
    MobilePhone?: string;
    WachterJobTitleId?: number;
    WachterJobTitle?: string;
    UserTypeCv?: number;
    UserTypeDisplay?: string;
    StaffingAgencyId?: number;
    ResourceGroupCv?: number;
    ResourceGroup?: string;
    EmployeeGroupId?: number;
    EmployeeGroupCode?: string;
    EmployeeGroupDescription?: string;
    empHireDate?: string;
    AddressLongitude?: number;
    AddressLatitude?: number;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    BirthMonth?: number;
    BirthDate?: number;
    Email?: string;
    SupervisorUserId?: number;
    UserStatusWs?: number;
    UserStatusMeaning?: string;
    IsTerminated?: boolean;
    PictureAttachmentFileExtension?: string;
    PictureAttachmentDisplay?: string;
    PictureAttachmentField?: number;
    AdjustedStartDate?: string;
    OfficeId?: number;
    OfficeName?: string;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceShortName?: string;
    PostalCode?: string;
    HasVehicle?: boolean;
    ShowUserOnMap?: boolean;
    RowInsertDateTime?: string;
    EmployeeType?: string;
    StateProvinceId?: number;
    PictureAttachmentFileKey?: string;
    CustomerId?: number;
    SubcontractorId?: number;
    SpecialInstructions?: string;
    isVaxxed?: boolean;

    // Display Attributes
    UserTypeCvDisplay?: string;
    WachterTeamIdDisplay?: string;
    WachterDepartmentIdDisplay?: string;
    // Relations
    SupervisorEthosUser? : EthosUserEntity[];
    ProofOfInsuranceJobTitlesWachterJobTitleId? : ProofOfInsuranceJobTitlesEntity[];
    EmployeeEthosProofOfInsuranceSummary? : ProofOfInsuranceSummaryEntity[];
    // Duplicate property excluded
    // SupervisorEthosUser : EthosUserEntity;
    RoEthosUser? : RoEthosUserEntity;
}

export interface EthosUserDiffEntity extends DwOrmData {
    // Attributes
    Ethos_UserDiffId?: number;
    Ethos_UserId?: number;
    FieldName?: string;
    OldValue?: string;
    NewValue?: string;
    ChangedDateTime?: string;

    // Relations
}

export interface EthosUserSkillEntity extends DwOrmData {
    // Attributes
    UserSkillId?: number;
    UserId?: number;
    SkillCv?: number;
    Dislay?: string;
    Meaning?: string;

    // Relations
}

export interface PolicyTypeEntity extends DwOrmData {
    // Attributes
    PolicyTypeId?: number;
    PolicyType?: string;

    // Relations
    ProofOfInsurance? : ProofOfInsuranceEntity[];
}

export interface ProofOfInsuranceEntity extends DwOrmData {
    // Attributes
    ProofOfInsuranceId?: number;
    PolicyNumber?: string;
    PolicyTypeId?: number;
    IssuedTo?: string;
    InsuranceCompany?: string;
    IssueDate?: string;
    ExpirationDate?: string;
    LicenseVerified?: boolean;
    POIStatusId?: number;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    AttachmentFileId?: number;
    Notes?: string;
    CountryId?: number;
    StateProvinceId?: number;
    VehicleTypeId?: number;
    ProofOfInsuranceSummaryId?: number;
    SignedCorpFleetPolicy?: boolean;
    IsCurrent?: boolean;

    // Display Attributes
    PolicyTypeIdDisplay?: string;
    POIStatusIdDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;
    AttachmentFileIdDisplay?: string;
    CountryIdDisplay?: string;
    StateProvinceIdDisplay?: string;
    VehicleTypeIdDisplay?: string;
    ProofOfInsuranceSummaryIdDisplay?: string;
    // Relations
    ProofOfInsuranceSummary? : ProofOfInsuranceSummaryEntity;
    ProofOfInsuranceStatus? : ProofOfInsuranceStatusEntity;
    VehicleType? : VehicleTypeEntity;
    // Duplicate property excluded
    // ProofOfInsuranceSummary : ProofOfInsuranceSummaryEntity;
    // Duplicate property excluded
    // ProofOfInsuranceSummary : ProofOfInsuranceSummaryEntity;
    PolicyType? : PolicyTypeEntity;
}

export interface ProofOfInsuranceJobTitlesEntity extends DwOrmData {
    // Attributes
    ProofOfInsuranceJobTitlesId?: number;
    WachterJobTitleId?: number;

    // Display Attributes
    WachterJobTitleIdDisplay?: string;
    // Relations
    EthosUserWachterJobTitleId? : EthosUserEntity;
}

export interface ProofOfInsuranceStatusEntity extends DwOrmData {
    // Attributes
    POIStatusId?: number;
    POIStatus?: string;
    ButtonClasses?: string;
    ValidationRequired?: boolean;
    StatusActionText?: string;

    // Relations
    ProofOfInsurance? : ProofOfInsuranceEntity[];
}

export interface ProofOfInsuranceSummaryEntity extends DwOrmData {
    // Attributes
    ProofOfInsuranceSummaryId?: number;
    IsApprovedDriver?: boolean;
    CanUsePersonalVehicle?: boolean;
    HasPoiOnPersonalVehicle?: boolean;
    NeedsTrustUpdate?: boolean;
    EmployeeEthos_UserId?: number;
    ProofOfInsuranceSummaryStatusId?: number;

    // Display Attributes
    EmployeeEthos_UserIdDisplay?: string;
    ProofOfInsuranceSummaryStatusIdDisplay?: string;
    // Relations
    ProofOfInsuranceSummaryStatus? : ProofOfInsuranceSummaryStatusEntity;
    ProofOfInsurance? : ProofOfInsuranceEntity[];
    // Duplicate property excluded
    // ProofOfInsurance : ProofOfInsuranceEntity[];
    EmployeeEthosEthosUser? : EthosUserEntity;
    // Duplicate property excluded
    // ProofOfInsurance : ProofOfInsuranceEntity[];
}

export interface ProofOfInsuranceSummaryStatusEntity extends DwOrmData {
    // Attributes
    ProofOfInsuranceSummaryStatusId?: number;
    ProofOfInsuranceSummaryStatusDisplay?: string;

    // Relations
    ProofOfInsuranceSummary? : ProofOfInsuranceSummaryEntity[];
}

export interface RoEthosUserEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    UserName?: string;
    FirstName?: string;
    LastName?: string;
    MiddleName?: string;
    PreferredName?: string;
    Suffix?: string;
    OfficePhone?: string;
    MobilePhone?: string;
    WachterJobTitleId?: number;
    WachterJobTitle?: string;
    UserTypeCv?: number;
    UserTypeDisplay?: string;
    StaffingAgencyId?: number;
    ResourceGroupCv?: number;
    ResourceGroup?: string;
    EmployeeGroupId?: number;
    EmployeeGroupCode?: string;
    EmployeeGroupDescription?: string;
    empHireDate?: string;
    AddressLongitude?: number;
    AddressLatitude?: number;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    BirthMonth?: number;
    BirthDate?: number;
    Email?: string;
    SupervisorUserId?: number;
    UserStatusWs?: number;
    UserStatusMeaning?: string;
    IsTerminated?: boolean;
    PictureAttachmentFileExtension?: string;
    PictureAttachmentDisplay?: string;
    PictureAttachmentField?: number;
    AdjustedStartDate?: string;
    OfficeId?: number;
    OfficeName?: string;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceShortName?: string;
    PostalCode?: string;
    HasVehicle?: boolean;
    ShowUserOnMap?: boolean;
    RowInsertDateTime?: string;
    TeamName?: string;
    TeamShortName?: string;
    TeamNickName?: string;
    DepartmentName?: string;
    DepartmentShortName?: string;
    WachterDivisionId?: number;
    DivisionName?: string;
    DivisionShortName?: string;
    NameLastFirst?: string;
    NameLastPrefered?: string;
    NameLastFirstPrefered?: string;
    NameFirstLast?: string;
    NamePreferedLast?: string;
    NameFirstPreferedLast?: string;
    NameFirstMiddleLast?: string;
    NamePreferedMidInitialLast?: string;
    NameLastFirstPreferedStatus?: string;
    EmployeeType?: string;
    StateProvinceId?: number;
    PictureAttachmentFileKey?: string;
    NameLastFirstPreferedType?: string;
    IsActive?: number;
    SpecialInstructions?: string;
    BirthMonthDate?: string;
    TerritoryId?: number;
    TerritoryName?: string;
    Company?: string;
    LicenseCount?: number;
    AXId?: string;

    // Display Attributes
    UserTypeCvDisplay?: string;
    WachterDepartmentIdDisplay?: string;
    SupervisorUserIdDisplay?: string;
    // Relations
    EthosUser? : EthosUserEntity;
    SupervisorRoEthosUser? : RoEthosUserEntity;
    // Duplicate property excluded
    // SupervisorRoEthosUser : RoEthosUserEntity[];
}

export interface RoEthosUserOriginalEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    AXId?: string;
    UserName?: string;
    FirstName?: string;
    LastName?: string;
    MiddleName?: string;
    PreferredName?: string;
    Suffix?: string;
    OfficePhone?: string;
    MobilePhone?: string;
    WachterJobTitleId?: number;
    WachterJobTitle?: string;
    UserTypeCv?: number;
    UserTypeDisplay?: string;
    EmployeeType?: string;
    StaffingAgencyId?: number;
    ResourceGroupCv?: number;
    ResourceGroup?: string;
    EmployeeGroupId?: number;
    EmployeeGroupCode?: string;
    EmployeeGroupDescription?: string;
    empHireDate?: string;
    AddressLongitude?: number;
    AddressLatitude?: number;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    BirthMonth?: number;
    BirthDate?: number;
    BirthMonthDate?: string;
    Email?: string;
    SupervisorUserId?: number;
    UserStatusWs?: number;
    UserStatusMeaning?: string;
    IsActive?: number;
    IsTerminated?: boolean;
    PictureAttachmentFileExtension?: string;
    PictureAttachmentDisplay?: string;
    PictureAttachmentFileKey?: string;
    PictureAttachmentField?: number;
    AdjustedStartDate?: string;
    OfficeId?: number;
    OfficeName?: string;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceId?: number;
    StateProvinceShortName?: string;
    TerritoryId?: number;
    TerritoryName?: string;
    PostalCode?: string;
    HasVehicle?: boolean;
    ShowUserOnMap?: boolean;
    SpecialInstructions?: string;
    RowInsertDateTime?: string;
    TeamName?: string;
    TeamShortName?: string;
    TeamNickName?: string;
    DepartmentName?: string;
    DepartmentShortName?: string;
    WachterDivisionId?: number;
    DivisionName?: string;
    DivisionShortName?: string;
    Company?: string;
    LicenseCount?: number;
    NameLastFirst?: string;
    NameLastPrefered?: string;
    NameLastFirstPrefered?: string;
    NameFirstLast?: string;
    NamePreferedLast?: string;
    NameFirstPreferedLast?: string;
    NameFirstMiddleLast?: string;
    NamePreferedMidInitialLast?: string;
    NameLastFirstPreferedStatus?: string;
    NameLastFirstPreferedType?: string;

    // Relations
}

export interface RoVehicleAccidentsEntity extends DwOrmData {
    // Attributes
    VehicleAccidentId?: number;
    EmployeeId?: number;
    PhoneNumber?: string;
    WJID?: string;
    AccidentDateTime?: string;
    AuthorityContacted?: string;
    ReportNumber?: string;
    DriverStreetAddress?: string;
    DriverCity?: string;
    DriverState?: number;
    DriverZip?: string;
    AccidentAddress?: string;
    AccidentCity?: string;
    AccidentState?: number;
    AccidentZip?: string;
    AccidentTypeCv?: number;
    AccidentAtFaultCv?: number;
    VehicleRepairedCv?: number;
    Injuries?: boolean;
    OOPClaimExpense?: string;
    InsurancePaidPDLTInsuredVehicle?: string;
    InsurancePaidPDLTClaimantVehicle?: string;
    OtherVehiclesInvolved?: boolean;
    IsDot?: boolean;
    AccidentDescription?: string;
    AttachmentId?: number;
    ClaimNumber?: string;
    ClaimStatusCv?: number;
    ClaimInsuranceCompanyCv?: number;
    ClaimInsuranceCompanyText?: string;
    AdvisorName?: string;
    AdvisorPhone?: string;
    ClaimFiledDate?: string;
    ClaimComments?: string;
    CreatedbyEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    SharepointMigrationId?: number;
    AccidentDateMonth?: string;
    StateDisplay?: string;
    IsPoliceReportObtained?: boolean;

    // Relations
}

export interface VehicleTypeEntity extends DwOrmData {
    // Attributes
    VehicleTypeId?: number;
    VehicleTypeDisplay?: string;

    // Relations
    ProofOfInsurance? : ProofOfInsuranceEntity[];
}



